import React, { lazy, Suspense } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import Loading from "components/shared-components/Loading";
import { AUTH_PREFIX_PATH } from "configs/AppConfig";

export const AppViews = () => {
	return (
		<Suspense fallback={<Loading cover="page" />}>
			<Switch>
				<Route
					path={`${AUTH_PREFIX_PATH}/welcome`}
					component={lazy(() => import(`./welcome`))}
				/>
				<Route
					path={`${AUTH_PREFIX_PATH}/consumidor-simulador`}
					component={lazy(() => import(`./consumidor-simulador`))}
				/>
				<Route
					path={`${AUTH_PREFIX_PATH}/consumidor-cadastro`}
					component={lazy(() => import(`./consumidor-cadastro`))}
				/>
				<Route
					path={`${AUTH_PREFIX_PATH}/consumidor-ofertas`}
					component={lazy(() => import(`./consumidor-ofertas`))}
				/>
				<Route
					path={`${AUTH_PREFIX_PATH}/consumidor-sucesso`}
					component={lazy(() => import(`./consumidor-sucesso`))}
				/>
				<Route
					path={`${AUTH_PREFIX_PATH}/termos-adesao`}
					component={lazy(() => import(`./termos-adesao`))}
				/>
				<Route
					path={`${AUTH_PREFIX_PATH}/gerador-cadastro`}
					component={lazy(() => import(`./gerador-cadastro`))}
				/>
				<Route
					path={`${AUTH_PREFIX_PATH}/comercializadora-cadastro`}
					component={lazy(() => import(`./comercializadora-cadastro`))}
				/>
				<Route
					path={`${AUTH_PREFIX_PATH}/parceiro-cadastro`}
					component={lazy(() => import(`./parceiro-cadastro`))}
				/>
				<Route
					path={`${AUTH_PREFIX_PATH}/credito-carbono-cadastro`}
					component={lazy(() => import(`./credito-carbono-cadastro`))}
				/>
				<Route
					path={`${AUTH_PREFIX_PATH}/credito-carbono-marketplace`}
					component={lazy(
						() => import(`./credito-carbono-marketplace`),
					)}
				/>
				<Route
					path={`${AUTH_PREFIX_PATH}/calculadora-emissoes`}
					component={lazy(() => import(`./calculadora-emissoes`))}
				/>
			<Route
				path={`${AUTH_PREFIX_PATH}/login-investidor`}
				component={lazy(
					() => import(`./authentication/login-investidor`),
				)}
			/>
			<Route
				path={`${AUTH_PREFIX_PATH}/investidor-cadastro`}
				component={lazy(() => import(`./investidor-cadastro`))}
			/>
			<Route
				path={`${AUTH_PREFIX_PATH}/vendas-ativo-cadastro`}
				component={lazy(() => import(`./vendas-ativo-cadastro`))}
			/>
			<Route
				path={`${AUTH_PREFIX_PATH}/login-vendedor-ativo`}
				component={lazy(
					() => import(`./authentication/login-vendedor-ativo`),
				)}
			/>
			<Route
				path={`${AUTH_PREFIX_PATH}/login`}
				component={lazy(() => import(`./authentication/login`))}
			/>
			<Route
				path={`${AUTH_PREFIX_PATH}/login-comercializadora`}
				component={lazy(
					() => import(`./authentication/login-comercializadora`),
				)}
			/>
			<Route
				path={`${AUTH_PREFIX_PATH}/login-parceiro`}
				component={lazy(
					() => import(`./authentication/login-parceiro`),
				)}
			/>
				<Route
					path={`${AUTH_PREFIX_PATH}/login-1`}
					component={lazy(() => import(`./authentication/login-1`))}
				/>
				<Route
					path={`${AUTH_PREFIX_PATH}/login-2`}
					component={lazy(() => import(`./authentication/login-2`))}
				/>
				<Route
					path={`${AUTH_PREFIX_PATH}/register-1`}
					component={lazy(
						() => import(`./authentication/register-1`),
					)}
				/>
				<Route
					path={`${AUTH_PREFIX_PATH}/register-2`}
					component={lazy(
						() => import(`./authentication/register-2`),
					)}
				/>
				<Route
					path={`${AUTH_PREFIX_PATH}/forgot-password`}
					component={lazy(
						() => import(`./authentication/forgot-password`),
					)}
				/>
				<Route
					path={`${AUTH_PREFIX_PATH}/error-1`}
					component={lazy(() => import(`./errors/error-page-1`))}
				/>
				<Route
					path={`${AUTH_PREFIX_PATH}/error-2`}
					component={lazy(() => import(`./errors/error-page-2`))}
				/>
				<Redirect
					from={`${AUTH_PREFIX_PATH}`}
					to={`${AUTH_PREFIX_PATH}/welcome`}
				/>
			</Switch>
		</Suspense>
	);
};

export default AppViews;
